import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { updateDataFields } from 'store/insurance/actions';
import { DATA_VALUE_FIELDS } from 'store/insurance/constants';
import { selectDataField } from 'store/insurance/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './TypeOfUse.constants';

export const useTypeOfUsePresenter = () => {
  const dispatch = useDispatch();

  const { [DATA_VALUE_FIELDS.ERROR]: error, [DATA_VALUE_FIELDS.VALUE]: value } = useSelector(
    selectDataField(NAME)
  );

  const { disabled: pageRestrict } = useDisabledFields();

  const onChange = useCallback(({ [NAME]: { id } }) => {
    dispatch(
      updateDataFields({
        [NAME]: {
          [DATA_VALUE_FIELDS.ERROR]: '',
          [DATA_VALUE_FIELDS.VALUE]: id,
        },
      })
    );
  }, []);

  return { disabled: pageRestrict, error, onChange, value };
};
